import { REQUEST_PARTIAL_VALIDATION_EVENT } from "../constants/custom-event-names"
import { assertIsCustomEvent } from "../hooks/use-validate-schema/helpers/assertIsCustomEvent"
import type { InputWithValidation, RequestValidationEventDetail } from "../types/EventDetailTypes"

/**
 * @description captures events on a provided input with custom validation,
 * and sets the `hasCustomValidation` property on the event's detail object
 *
 * @listens RequestPartialValidation
 * */
export const captureEventAndMarkTargetAsInputWithCustomValidation = (source: HTMLDivElement | InputWithValidation, signal: AbortSignal) => {
    source.addEventListener(REQUEST_PARTIAL_VALIDATION_EVENT, (e) => {
        const event = e as CustomEvent<RequestValidationEventDetail>
        assertIsCustomEvent(event)
        /* eslint-disable-next-line -- Assignment to property of function parameter
         * Deliberately mutating the event. Other listeners are also acting on this
         * reference of the object
         * */
        event.detail.hasCustomValidation = true
    }, { capture: true, signal })
}
